






























































































































































































import Vue from 'vue';
import store, { TransactionStore } from "../services/TransactionStore";
import ApiSearchPageForLedger from '@/components/apiSearch/components/ApiSearchPageForLedger.vue';
import TransactionItems from "@/modules/transactions/views/TransactionItems.vue";
import ReconBasketMenu from "@/modules/transactions/components/ReconBasketMenu.vue";
import http, { handleApiResponse } from '@/services/http';
import ApiResponse from '@/models/ApiResponse';
import Country from '@/modules/cashPoint/models/Country';
import eventBus from '@/services/eventBus';
import CheckBox from "@/components/CheckBox.vue";
import { Grid } from '@progress/kendo-vue-grid';
import { SortDescriptor, CompositeFilterDescriptor, } from '@progress/kendo-data-query';
import ApiSearch from "../../../components/apiSearch/models/ApiSearch"
import links from "../../../models/Links";
import TransactionItem from '../models/TransactionItem';
import { MultiSelect, DropDownList } from "@progress/kendo-vue-dropdowns";
import ApiSearchResult from '@/components/apiSearch/models/ApiSearchResult';
import TransactionApi from "../services/TransactionApi";
import { saveSearchState, getSearchState } from "@/components/apiSearch/services/searchStateMemory";

/** A grid Kendo-tükreinek pillanatkép-kulcsa és alakja (a szűrőértékeké a 'ledger-transactions'). */
const GRID_STATE_KEY = "ledger-transactions-grid";
interface GridMirrorSnapshot {
  sort: SortDescriptor[];
  filter: CompositeFilterDescriptor;
  showSpecDims: boolean;
}


interface Data {
  transStats: any[];
  currencies: Country[];
  periods: any[];
  bookTypes: any[];
  store: TransactionStore;
  sort: SortDescriptor[];
  filter: CompositeFilterDescriptor;
  showLoader: boolean;
  showSpecDims: boolean;
}
interface Methods{
  create(): void;
  emitSetSelected(item: any): void;
  copy(item: any, mode: string): void;
  modify(item: any): void;
  sortChangeHandler(e: any, apiSearch: ApiSearch): void;
  filterChangeHandler(e: any, apiSearch: ApiSearch): void;
  partnerEdit(item: TransactionItem): void;
  dropdownFilterChange(item: any, apiSearch: ApiSearch): void;
  doReverse(payload: { items: any[]; date: string }, mode: string): Promise<void>;
  toggleSpecDims(): void;
  rowRender(h: any, trElement: any, defaultSlots: any, props: any): any;
  clearExclusiveIds(): void;
  onResetFiltering(): void;
  allDetailsOpen(items: any[]): boolean;
  toggleAllDetails(items: any[]): void;
}
interface Computed {
  columns: any[];
  exclusiveIds: number[];
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    ApiSearchPageForLedger,
    TransactionItems,
    ReconBasketMenu,
    CheckBox,
    Grid,
    // MultiSelect,
    DropDownList,
  },

  data() {
    // A grid Kendo-tükreit (szűrőcella-értékek, rendezés-nyíl, spec.dim oszlopok láthatósága)
    // ugyanabból a memória-tárból töltjük vissza, ahová az ApiSearchPageForLedger a tényleges
    // szűrőértékeket menti — így a felület és a keresés együtt áll vissza. F5 törli.
    const saved = getSearchState<GridMirrorSnapshot>(GRID_STATE_KEY);
    return {
      transStats: [],
      currencies: [],
      periods: [],
      bookTypes: [],
      store,
      sort: saved ? saved.sort : [],
      filter: saved ? saved.filter : { logic: "and", filters: [] },
      showLoader: true,
      showSpecDims: saved ? saved.showSpecDims : false,
    }
  },

  beforeDestroy() {
    saveSearchState(GRID_STATE_KEY, {
      sort: this.sort,
      filter: this.filter,
      showSpecDims: this.showSpecDims,
    } as GridMirrorSnapshot);
  },

  async beforeMount() {
    this.transStats = await http.get<ApiResponse<any[]>>("general-ledger-transaction/detail/trans-stats").then(handleApiResponse);
    this.currencies = await http.get<ApiResponse<Country[]>>("currency").then(handleApiResponse);
    // this.periods = await http.get<ApiResponse<any[]>>("general-ledger-transaction/head/periods").then(handleApiResponse);
    this.bookTypes = await http.get<ApiResponse<any[]>>("general-ledger-transaction/detail/book-types").then(handleApiResponse);
  },

  methods: {
    create(){
      this.$router.push(`/transactions/create/1`);
    },

    emitSetSelected(item: any) {
      eventBus.$emit("ledger-transactions:setSelected", item);
    },

    // A 'selected' a Kendo expand-field (tétel-nézet), NEM a kijelölés (az a selectedStatus)
    allDetailsOpen(items) {
      return !!items && items.length > 0 && items.every((x: any) => x.selected);
    },

    // Ha mind nyitva → mind be; egyébként mind ki (a részben nyitott állapot is "mind ki"-t ad)
    toggleAllDetails(items) {
      const open = !this.allDetailsOpen(items);
      (items || []).forEach((x: any) => { x.selected = open; });
    },
    copy(item,mode){
      this.$router.push({
          name: "TransactionCopy",
          params: { id: item[0].id },
          query: { mode: mode }
        });
    },
    modify(item){
      this.$router.push({
          name: "TransactionEdit",
          params: { id: item[0].id },
        });
    },
    sortChangeHandler(e, apiSearch){
      if(e.sort.length == 0){
        apiSearch.sort?.toggle(this.sort[0].field)
        this.sort = e.sort;
        return
      }
      this.sort = e.sort;
      apiSearch.sort?.toggle(this.sort[0].field)
    },

    filterChangeHandler(e, apiSearch){
      if(!apiSearch.filter)
        return

      if(e.filter == null){
        (apiSearch.filter.filters[e.event.field] as any).value = null
      }else{
        (apiSearch.filter.filters[e.event.field] as any).value = e.event.value;
      }
      this.filter = e.filter;  
    },
    dropdownFilterChange(item, apiSearch){
      if(!apiSearch.filter)
        return

      if(item.target.value.name === "Összes"){
        (apiSearch.filter.filters[item.target.name] as any).value = null
      }else{
        (apiSearch.filter.filters[item.target.name] as any).value = item.target.value.name;
      }
    },
    partnerEdit(item: TransactionItem) {
      links.activate.partnerProfileFromTransaction(item);
    },

    // Az ID-szűrő capsule X-e: a query nélküli útvonalra váltunk (a fullPath-kulcsos
    // router-view újramountol, a többi szűrő a memória-tárból visszaáll).
    clearExclusiveIds() {
      if (this.$route.query.ids) {
        this.$router.replace("/transactions");
      }
    },

    // "Szűrés eltávolítása": a Kendo szűrőcellák vizuális tükrét is ürítjük
    // (a tényleges szűrőértékeket a kereső komponens állítja vissza).
    onResetFiltering() {
      this.filter = { logic: "and", filters: [] };
    },

    toggleSpecDims() {
      this.showSpecDims = !this.showSpecDims;
      // Kikapcsoláskor a rejtett oszlopok Kendo szűrő-cellái is ürüljenek, hogy
      // visszakapcsolva ne maradjon bent láthatatlanul beírt érték.
      if (!this.showSpecDims && this.filter && Array.isArray(this.filter.filters)) {
        this.filter = {
          ...this.filter,
          filters: (this.filter.filters as any[]).filter(
            (f: any) => !String(f.field || "").startsWith("specDim")
          ),
        };
      }
    },

    // K2D d_g_hxboktrans: a sztornó (storno='+') sorok világos piros háttere — rgb(255,150,150).
    rowRender(h: any, trElement: any, defaultSlots: any, props: any) {
      const trProps = { style: props.dataItem.storno ? "backgroundColor: rgb(255,150,150)" : "" };
      return h("tr", trProps, defaultSlots);
    },

    // K2D "Javítás → Ellentett kontírozás/összeg": a kijelölt tranzakció(k) ellentételezése. A dátumot a gombhoz
    // horgonyzott popover (ApiSearchPageForLedger) gyűjti be, és { items, date } payloadként küldi fel.
    // mode "K" = előjel-fordítás, "O" = összeg-negálás. A backend tranzakciónként ad vissza egy ValidationResult-ot
    // (siker/hiba üzenettel), amit az eventBus-on jelenítünk meg.
    async doReverse(payload, mode) {
      const ids = (payload.items || []).map((x: any) => x.id);
      if (ids.length < 1) {
        eventBus.$emit("warn", "Jelölj ki legalább egy tranzakciót!");
        return;
      }
      if (!payload.date) {
        return;
      }
      try {
        const messages = await TransactionApi.reverseTransactions(mode, ids, payload.date);
        (messages || []).forEach((m: any) => {
          eventBus.$emit(m.isValid ? "success" : "error", m.message);
        });
        eventBus.$emit("ledger-transactions:reload");
      } catch (e) {
        eventBus.$emit("error", "Az ellentételezés nem sikerült!");
      }
    },
  },

  computed: {
    // A tranzakció import "Megtekintés" linkje ?ids=1,2 query-vel érkezik: csak ezek a
    // tranzakciók látszanak (a backend ilyenkor minden más szűrőt figyelmen kívül hagy).
    exclusiveIds(): number[] {
      const raw = this.$route.query.ids;
      if (!raw) return [];
      return String(raw)
        .split(",")
        .map((x) => Number(x))
        .filter((x) => Number.isFinite(x) && x > 0);
    },

    // Bővített nézetben (showSpecDims) a sor végén megjelenik a négy spec. dimenzió oszlop
    // (K2D d_g_hxboktrans: spec_dim1-4 az utolsó négy oszlop), és helyet adva nekik a
    // Könyvelés dátuma + Sztornózott tranzakció oszlopok fix keskeny szélességet kapnak.
    columns(): any[] {
      return [
      {
        filterable: false,
        cell: "detailTemplate",
        headerCell: "detailHeaderTemplate",
        // Tartalomhoz méretezve: kijelölő + 2 gomb ≈ 108px + 2×8px cella-padding
        width: "125px"
      },
      {
        field: "id",
        title: "Azonosító",
      },
      {
        field: "partnerName",
        title: "Partner",
        cell: "partnerTemplate",
      },
      {
        field: "accEvent",
        title: "Gazdasági esemény"
      },
      {
        field: "accDate",
        title: "Könyvelés dátuma",
        headerClassName: "left_text",
        className: "right_text",
        ...(this.showSpecDims ? { width: "115px" } : {}),
        // type: ColumnType.Date
      },
      {
        field: "storno",
        title: "Sztornó?",
        // filterCell: 'stornoFilter',
        cell: "stornoTemplate",
        headerClassName: "center_text",
        filterable: false,
        sortable: false,
      },
      {
        field: "transSt",
        title: "Sztornózott tranzakció",
        ...(this.showSpecDims ? { width: "125px" } : {}),
      },
      {
        field: "periodName",
        title: "Periódus",
        // Az oszlop-szűrő nem kell: a periódusra a panel Periódusok választója szűr
        filterable: false,
      },
      {
        field: "statusName",
        title: "Állapot",
        // filterCell: "statusFilterTemplate"
        filterable: false,
      },
      {
        field: "typeName",
        title: "Tr típus",
        // filterCell: "typeFilterTemplate"
        filterable: false,
      },
      {
        field: "remark",
        title: "Megjegyzés"
      },
      {
        field: "specDim1",
        title: "Munkaszám",
        hidden: !this.showSpecDims,
        width: "105px"
      },
      {
        field: "specDim2",
        title: "Gépjármű",
        hidden: !this.showSpecDims,
        width: "105px"
      },
      {
        field: "specDim3",
        title: "Szerelő",
        hidden: !this.showSpecDims,
        width: "105px"
      },
      {
        field: "specDim4",
        title: "Szerviztípus",
        hidden: !this.showSpecDims,
        width: "105px"
      },
      // {
      //   cell: "editTemplate",
      //   filterable: false,
      // },
      {
        filterable: false,
        width: 0
      }
      ];
    },
  },
})
